import React, { useState, FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { endOfMonth, startOfMonth } from './utils';
import { deafaultLastDate, deafaultStartDate } from './utils';
import { weekDays } from './utils';

import {
  FilterType,
  HandleFilterType,
  ModalState,
  ShiftClickHanlederType,
} from './types';

import { useMyShiftRoster } from './api';

import './shift-and-schedule.css';

import { Grid, Modal } from '@mui/material';
import {
  ShiftDayCell,
  Filters,
  SwapShiftConfirmation,
  EditSwap,
} from './components';
import { Backdrop } from '../../../../../components';

const gridOptions = {
  xs: 1.71,
  minHeight: '90px',
  minWidth: '70px',
  flexShrink: 0,
};

const gridOptionsHead = {
  xs: 1.71,
  minHeight: '50px',
  minWidth: '70px',
  flexShrink: 0,
};

const ShiftAndShcedule2: FC = () => {
  const [filter, setFilter] = useState<FilterType>({
    startDate: startOfMonth,
    endDate: endOfMonth,
  });
  const [modal, setModal] = useState<ModalState>({ open: false, data: {} });
  const [editModal, setEditModal] = useState<ModalState>({
    open: false,
    data: {},
  });

  const navigate = useNavigate();

  const { data, isLoading, refetch } = useMyShiftRoster({
    params: {
      startDate: deafaultStartDate({
        date: filter?.startDate,
      }).format('YYYY-MM-DD'),
      endDate: deafaultLastDate({ date: filter?.endDate }).format('YYYY-MM-DD'),
    },
  });

  const handleFilter = ({ key, value, resetFilter }: HandleFilterType) => {
    if (resetFilter) {
      setFilter((prev) => ({ ...prev, ...resetFilter }));
      return;
    }
    setFilter((prev) => ({ ...prev, [`${key}`]: value }));
  };

  const toggleModal = () => {
    setModal((prev: ModalState) => ({ open: !prev.open, data: {} }));
  };

  const toggleEditModal = () => {
    setEditModal((prev: ModalState) => ({ open: !prev.open, data: {} }));
  };

  const onClickOnShift = ({ rowIndex, columnData }: ShiftClickHanlederType) => {
    const employeeDetails = data;

    const employee = {
      id: employeeDetails?.employeeId,
      name: employeeDetails?.employeeName,
      profilePic: employeeDetails?.employeeProfileImage,
      department: employeeDetails?.employeeDepartmentName,
    };

    if (columnData.isSwapped) {
      setEditModal({
        open: true,
        data: {
          ...columnData,
          employee,
        },
      });
      return;
    }

    setModal({
      open: true,
      data: { ...columnData, employee },
    });
  };

  const onSwapShiftConfirm = () => {
    navigate(
      `swap-shift?id=${modal?.data?.employee?.id}&start-date=${modal?.data?.date}`,
    );
  };

  return (
    <>
      <Backdrop open={isLoading} />
      <div className="time-shift-container">
        <div className="time-shift-filters">
          <p className="time-shift-title">Shift & Schedule</p>
          <Filters handleFilter={handleFilter} filter={filter} />
        </div>
        <Grid container minWidth={'1067px'} spacing={1} padding={'10px'}>
          {weekDays?.map((day) => (
            <Grid item {...gridOptionsHead} key={day}>
              <div className="time-shift-day-head">
                <p className="time-shift-day-head-text">{day}</p>
              </div>
            </Grid>
          ))}
          {data?.shifts?.map((day: any) => {
            return (
              <Grid item {...gridOptions} key={day?.date}>
                <ShiftDayCell
                  day={day}
                  startOfMonth={filter?.startDate}
                  onClick={onClickOnShift}
                />
              </Grid>
            );
          })}
        </Grid>
        <Modal open={modal?.open} onClose={toggleModal}>
          <SwapShiftConfirmation
            data={modal?.data}
            toggleModal={toggleModal}
            onConfirm={onSwapShiftConfirm}
          />
        </Modal>
        <Modal open={editModal?.open} onClose={toggleEditModal}>
          <EditSwap
            data={editModal?.data}
            toggleModal={toggleEditModal}
            onEdited={refetch}
          />
        </Modal>
      </div>
    </>
  );
};

export default ShiftAndShcedule2;
